import React from 'react'
import { Link } from 'react-router-dom'

const Logo = () => {
	return (
		<div className='logo'>
			<h1><Link to="/">Alishly.com</Link></h1>
		</div>
	)
}

export default Logo